
import React, { InputHTMLAttributes, useRef, useState } from 'react'

import './InputText.scss'

interface Props extends Omit<InputHTMLAttributes<HTMLInputElement>, "onChange"> {
  placeholder?: string
  icon?: JSX.Element
  onEnter?: () => void
  onChange?: (value: string) => void
}

const InputText = (props: Props) => {

  const { placeholder, icon, onChange, ...rest } = props

  const inputRef = useRef<HTMLInputElement>(null)

  const [ isFocused, setIsFocused ] = useState(false)

  return (
    <div className={`input-text ${isFocused ? 'focused' : ''}`}
      onClick={() => {

        if (inputRef.current) {
          inputRef.current.focus()
        }
      }}
    >
      {!!icon && (
        <div className="icon-container">
          {icon}
        </div>
      )}
      <input
        ref={inputRef}
        className='input-control'
        type="text"
        placeholder={placeholder}
        onChange={(e: any) => {

          if (onChange) {
            onChange(e.target.value)
          }
        }}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        {...rest}
      />
    </div>
  )
}

export default InputText
